import { Range } from 'rc-slider';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const StyledRange = styled(Range)`
  & > .rc-slider-track,
  & > .rc-slider-handle {
    background-color: ${ColorPalette.HEX.PortlandOrange};
    border: none !important;
  }

  & > .rc-slider-handle-dragging {
    box-shadow: 0 0 0 2px ${ColorPalette.HEX.PortlandOrange} !important;
  }
`;
